export enum OrderStatus {
  CANCELED = 'CANCELED',
  CONFIRMATION_FAILED = 'CONFIRMATION_FAILED',
  CONFIRMATION_REQUESTED = 'CONFIRMATION_REQUESTED',
  CONFIRMED = 'CONFIRMED',
  CREATED = 'CREATED',
  ERRORS = 'ERRORS',
  HOLD = 'HOLD',
  NOT_REQUESTED = 'NOT_REQUESTED',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  PICKUP_CREATED = 'PICKUP_CREATED',
  PICKUP_FAILED = 'PICKUP_FAILED',
  PICKUP_NOT_REQUESTED = 'PICKUP_NOT_REQUESTED',
  READY = 'READY', // ready for request
  REQUESTED = 'REQUESTED',
  SUCCESS = 'SUCCESS',
  VALIDATION_FAILED = 'VALIDATION_FAILED',
  WAITING = 'WAITING',
}
